export default {
  NOT_FOUND: 404,
  NOT_EXISTENT: 10021,
  UNAUTHORIZED: 401,
  UNBIND_PHONE: 10001,
  NO_PERMISSION_EDIT: 10002,
  UPLOAD_WAF_INTERCEPT: 405,
};
